export default {"src":"/_next/static/media/foldersInactive.2c5e9861.svg","height":18,"width":18};